export default __webpack_public_path__ + "static/jeffrey wojcik-734ea708a249587ad138c0780cdf9896.png";